<div>
    <table class="budget-taxyear-create-missing-table">
        <tr>
            <td>
                <label style="margin-bottom: 0;">Missing Parcel {{ taxYear }} Tax Years:</label>
            </td>
            <td></td>
            <td>
                {{ missingSyncData.numMissingTaxYears }}
            </td>
            <td></td>
            <td rowspan="2">
                @if (editMode) {
                    <button [disabled]="!isMissingCreateAllowed()"
                            class="ace-btn btn-sm btn-primary"
                            (click)="createMissing()">
                        Create
                    </button>
                }
            </td>
        </tr>
        <tr>
            <td>
                <label style="margin-bottom: 0;">Missing Parcel Budgets:</label>
            </td>
            <td></td>
            <td>
                {{ missingSyncData.numMissingBudgets }}
            </td>
            <td></td>
        </tr>
    </table>
</div>
